module.exports = __webpack_public_path__ + "./MarcoPhoto_9048f994c071785602cb6b4671465ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/MarcoPhoto.png
// module id = 537
// module chunks = 0